module.exports = "/_next/static/public/images/9af4998dc896c7e511a2a2da7bbd597b-5d239b814ea93cd9193a8164d360946b.png";